<template>
  <div>
    <div v-if="searchForm" class="mb-0">{{ $t('inimeste_arv') }}:</div>
    <v-select
      :label="searchForm ? '' : $i18n.t('inimeste_arv') + ' *'"
      ref="vSelect"
      :placeholder="selectedPersonsText"
      :persistent-placeholder="searchForm || !!selectedPersonsText"
      :dense="sidebar || searchForm"
      :items="[]"
      :menu-props="!isMobileView && sidebar ? { contentClass: 'search-wide-input-menu' } : {}"
      outlined
      hide-details
    >
      <template v-slot:no-data>
        <v-container :class="classes">
          <v-row
            class="my-0 mt-0 mb-2 align-center"
            dense
            style="border-bottom: 1px solid #ddd; padding-bottom: 5px; margin-bottom: 5px;"
            @click="close"
          >
            <v-col cols="1" text-center />
            <v-col
              :cols="sidebar ? 9 : 10"
              class="text-center"
            >
              <b v-if="!searchForm">{{ $i18n.t('inimeste_arv') }}</b>
            </v-col>
            <v-col
              :cols="sidebar ? 2 : 1"
              class="text-right"
            >
              <v-btn
                small dark fab icon outlined
                class="form-close mr-2"
                color="green"
                @click="close"
              >
                <v-icon small>fa-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-for="(personType, pti) in personTypes"
            :key="pti"
            class="align-center"
            dense
          >
            <v-col cols="7">
              {{ $i18n.t(personType + '_count') }}
            </v-col>

            <v-col cols="5" class="text-center">
              <v-container class="pa-0">
                <v-row class="align-center" no-gutters>
                  <v-col
                    cols="4"
                    class="text-right"
                  >
                    <v-btn
                      :small="!isMobileView"
                      class="plus-minus-btn sidebar-plus elevation-0 mx-0"
                      color="#219bc8"
                      dark
                      fab
                      @click="$emit('removePerson', personType)"
                    >
                      <v-icon small>fa-minus</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    :cols="sidebar ? 4 : 4"
                    :class="'text-center ' + (sidebar ? 'pa-0' : '')"
                  >
                    {{ bookingData[personType] }}
                  </v-col>
                  <v-col
                    cols="4"
                    :class="'text-left ' + (sidebar ? 'pa-0' : '')"
                  >
                    <v-btn
                      class="plus-minus-btn sidebar-plus elevation-0 mx-0"
                      color="#219bc8"
                      dark
                      fab
                      @click="$emit('addPerson', personType)"
                    >
                      <v-icon small>fa-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-select>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import sharedComputed from '@/methods/sharedComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'BookingFormVisitorSelect',

  props: {
    sidebar: {
      type: Boolean,
      default: false,
    },
    searchForm: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    classes () {
      const classes = []
      classes.push(this.sidebar ? 'popup-select-container-sidebar' : 'popup-select-container')
      classes.push(this.searchForm ? 'elevation-0' : 'elevation-0')
      classes.push(this.searchForm ? 'px-3 py-0' : '')
      classes.push(this.searchForm ? 'white' : '')
      return classes
    },
  },

  methods: {
    close () {
      const searchEl = this.$refs.vSelect
      if (searchEl) {
        searchEl.blur()
      }
    },
  },
}
</script>
